<script setup lang="ts">
import { computed } from 'vue';
import { useUsersStore } from '@/stores';
import { storeToRefs } from 'pinia';

const props = defineProps<{
  rolesAllowed?: number[];
  requiresSuperadmin?: boolean;
}>();

const { currentUser } = storeToRefs(useUsersStore());

const isUserAuthorized = computed(() => {
  if (props.requiresSuperadmin) {
    return currentUser.value?.isSuperadmin ?? false;
  }

  const role = currentUser.value?.role;
  return role !== undefined && (props.rolesAllowed ?? []).includes(role);
});
</script>

<template>
  <div v-if="isUserAuthorized">
    <slot></slot>
  </div>
</template>
